<h2 mat-dialog-title translate>Comments on Changes</h2>
<mat-dialog-content>
    <div translate style="padding-bottom: 10px;">
        Enter comments explaining what was changed and why. <br/>
        (These will show in the Change History.)
    </div>
    <form #form="ngForm">
        <tyl-form-field label='Comments' style="width:100%;" hint="{{1000 - comment.length}} characters left">
            <textarea #frmaComment [attr.tylerastid]="'txtFRMAComment'" matInput id='txtFRMAComment' name='FRMAComment' [(ngModel)]='comment' required maxlength="1000"></textarea>
        </tyl-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    </div>
</mat-dialog-actions>